<template>
  <ContainerBasic container-type="CONTENT" class="px-sm md:px-0">
    <HeadlineDynamic
      v-if="blockData.headline"
      :has-decoration="true"
      :headline="blockData.headline"
      level="h2"
      class="pt-md md:pt-xl"
    />
    <div
      class="grid grid-cols-1 gap-x-md gap-y-sm mt-md md:mt-xl"
      :class="blockData.columns === 2 ? 'md:grid-cols-2' : ''"
    >
      <div
        v-for="item in blockData.items"
        :key="item.id"
        class="flex flex-row items-center col-span-1 leading-tight px-xs py-xs bg-vdv-grey flex-nowrap text-vdv-font"
      >
        <FaIcon :icon="item.icon" classes="fa-fw ml-0 h-[16px] md:ml-[20px]" />
        <span class="font-bold ml-xs md:ml-sm">{{ t(item.headline) }}</span>
        <span class="w-1/2 ml-auto pl-sm md:pl-md">
          {{ item.description }}
        </span>
      </div>
    </div>
  </ContainerBasic>
</template>
<script lang="ts" setup>
import ContainerBasic from '@/components/components/container-basic.vue';
import HeadlineDynamic from '@/components/components/core/headline-dynamic/vdv/headline-dynamic.vue';
import type { GridTableData } from '../blockType';
import FaIcon from '@/components/fa-icon.vue';

const { t } = useTrans();

defineProps({
  blockData: {
    type: Object as PropType<GridTableData>,
    required: true,
    default: {} as GridTableData,
  },
});
</script>
